
/**
 * Signe Local — Notes du panier
 * Limite de 250 caractères et compteur dynamique.
 * Compatible avec le panier AJAX du thème Impact.
 */
(() => {
  const MAX_LENGTH = 250;
  const SELECTOR = 'cart-note textarea[name="note"], cart-note input[name="note"]';

  function updateField(field) {
    if (!field || !field.matches(SELECTOR)) return;

    field.maxLength = MAX_LENGTH;

    if (field.value.length > MAX_LENGTH) {
      field.value = field.value.slice(0, MAX_LENGTH);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    let counter = field.parentElement.querySelector(
      '.sl-cart-note-counter'
    );

    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'sl-cart-note-counter';
      counter.setAttribute('role', 'status');
      counter.setAttribute('aria-live', 'off');
      field.insertAdjacentElement('afterend', counter);
    }

    const remaining = MAX_LENGTH - field.value.length;
    const isEnglish = document.documentElement.lang
      .toLowerCase().startsWith('en');

    counter.textContent = isEnglish
      ? `${remaining} characters remaining`
      : `${remaining} caractères restants`;

    counter.classList.toggle(
      'sl-cart-note-counter--warning',
      remaining <= 20
    );
  }

  document.addEventListener('focusin', event => {
    updateField(event.target);
  });

  document.addEventListener('input', event => {
    updateField(event.target);
  });

  function initialize() {
    document.querySelectorAll(SELECTOR).forEach(updateField);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
